import React, { ReactElement } from 'react';
import { motion } from 'framer-motion';

import COLORS from '~/constants/colors';

import { RendererProps } from '../../models';
import { getPx } from '../../helpers';
import { BAR_VARIANTS } from '../../constants/layout';

function Bar({ entity }: RendererProps): ReactElement {
  const pos = entity.getPos();
  const needsFadeIn = entity.state === BAR_VARIANTS.fadeIn;

  // Styling
  const barStyle = {
    position: 'absolute' as const,
    width: getPx(entity.dims.w),
    height: getPx(entity.dims.h),
    left: getPx(pos.x - entity.dims.w / 2),
    top: getPx(pos.y - entity.dims.h / 2),
    opacity: needsFadeIn ? 0 : 1,
    borderColor: entity.fuzzy ? COLORS.white25 : COLORS.white75,
    borderStyle: 'dashed',
    borderWidth: `${getPx(1)} 0 0`,
    zIndex: 1,
  };

  // Animation
  const variants = {
    reset: {
      opacity: 1,
    },
    fadeIn: {
      opacity: [0, 1],
      transition: { duration: 0.25 },
    },
    fadeOut: {
      opacity: [1, 0],
      transition: { duration: 0.25 },
    },
  };
  const animate = entity.state ?? 'reset';

  return (
    <motion.div
      {...(!needsFadeIn && { initial: false })}
      style={barStyle}
      animate={animate}
      variants={variants}
    />
  );
}

export default Bar;
